<template>
  <div style="height:100%" class="_home">
    <v-app-bar app fixed flat :color="scdColor" clipped-left>
      <img data-tour-step-simulazioni="0" class="hidden-sm-and-down" src="/img/logo-white.png" style="max-height:98%; cursor:pointer;" alt="Simulatore Click Day" @click="goToDashboard">
      <v-divider v-if="!$vuetify.breakpoint.smAndDown" vertical style="border-color:#6d94cd;" class="mx-3"></v-divider>
      <v-toolbar-title v-if="!$vuetify.breakpoint.smAndDown">
        <v-col>
          <v-row>
            <span style="font-size: 15px; color: white;">
              Utente:<b>{{' ' + username}}</b>
            </span>
          </v-row>
          <v-row>
          <span style="font-size: 15px; color: white;">
              Ruolo:<b>{{ruolo == 'Admin' ? ' Amministratore' : (ruolo == 'Teamleader' ? ' Coordinatore' : ' Cliccatore')}}</b>
          </span>
          </v-row>
        </v-col>
      </v-toolbar-title>

      <v-spacer v-if="!$vuetify.breakpoint.smAndDown"></v-spacer>

      <!-- MENU MOBILE -->
      <!-- // TODO: la guida non mostra le voci di menu su schermi piccoli -->
      <v-menu v-if="$vuetify.breakpoint.smAndDown" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn depressed text tile small class="white--text" v-on="on">
            <v-icon>menu</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="computedAmIAdmin" to="/account">
            <v-list-item-title>Account</v-list-item-title>
          </v-list-item>
          <v-list-item to="/simulazioni">
            <v-list-item-title>Simulazioni</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="amIAdminOrTeamleader && !amIProvaGratuita" to="/cliccatori">
            <v-list-item-title>Cliccatori</v-list-item-title>
          </v-list-item>
          
          <v-list v-if="bandoConSimulazioni">
            <v-list-item v-if="!amIProvaGratuita" to="statistiche_cliccatore">
              <v-list-item-title>Statistiche personali</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="amIAdminOrTeamleader && !amIProvaGratuita" to="statistiche_squadre">
              <v-list-item-title>Statistiche squadre</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="computedAmIAdmin && !amIProvaGratuita" to="statistiche_azienda" disabled>
              <v-list-item-title>Statistiche aziendali</v-list-item-title>
            </v-list-item>
            <!-- GAMING -->
            <v-list-item v-if="gamingAbilitato" :to="{ name: 'gaming-dashboard-route'}">
              <v-list-item-title>Gaming</v-list-item-title>
            </v-list-item>
            <!-- <v-list-item v-if="computedDatiCliccatoreEnabled" @click="popUpDatiCliccatore()">
              <v-list-item-title>Dati Cliccatore</v-list-item-title>
            </v-list-item> -->
          </v-list>

          
          
          <!-- <v-list-item @click="openGuide()">
            <v-list-item-title>Guida</v-list-item-title>
          </v-list-item> -->
          <v-list-item @click="apriProfiloDialog()">
            <v-list-item-title>Profilo</v-list-item-title>
          </v-list-item>
          <v-list-item @click="doLogout()">
            <v-list-item-title>Esci</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- MENU DESKTOP -->
      <v-toolbar-items v-else class="menu_buttons_uppercase">
        <!-- <v-tooltip v-if="amIProvaGratuita" bottom>
          <template v-slot:activator="{ on }">
            <v-btn style="cursor:default;" color="white" text data-tour-step="account" v-on="on">Account</v-btn>
          </template>
          <span>Non disponibile in versione di prova</span>
        </v-tooltip> -->
        <v-btn v-if="computedAmIAdmin" color="white" to="/account" text data-tour-step-account="1" data-tour-step="account">Account</v-btn>
        
        <v-btn color="white" to="/" text>Simulazioni</v-btn>
        
        <v-tooltip v-if="amIProvaGratuita" bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="white" style="cursor:default;" text data-tour-step="cliccatori" v-on="on">Cliccatori</v-btn>
          </template>
          <span>Non disponibile in versione di prova</span>
        </v-tooltip>
        <v-btn v-else-if="amIAdminOrTeamleader" color="white" to="/cliccatori" text data-tour-step="cliccatori" data-tour-step-cliccatori="0">Cliccatori</v-btn>
        
        <v-tooltip v-if="amIProvaGratuita" bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" color="white" style="cursor:default;" text data-tour-step="statistiche">Statistiche</v-btn>
          </template>
          <span>Non disponibile in versione di prova</span>
        </v-tooltip>
				<!--<v-tooltip v-else bottom :color="scdColor">-->
				<!--	<template v-slot:activator="{ on }">-->
				<!--		<v-btn v-on="on" color="white" style="cursor:default;" text data-tour-step="statistiche">Statistiche</v-btn>-->
				<!--	</template>-->
				<!--	<span>In manutenzione</span>-->
				<!--</v-tooltip>-->
        <v-menu v-else-if="bandoConSimulazioni" transition="slide-y-transition" bottom left nudge-bottom="50" tile>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" color="white" text data-tour-step="statistiche">Statistiche</v-btn>
          </template>
          <v-list style="border-radius:0">
            <v-list-item to="statistiche_cliccatore">
              <v-list-item-title>Statistiche personali</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="amIAdminOrTeamleader && !amIProvaGratuita" to="statistiche_squadre">
              <v-list-item-title>Statistiche squadre</v-list-item-title>
            </v-list-item>
            <!--<v-list-item v-if="computedAmIAdmin && !amIProvaGratuita" to="statistiche_azienda">-->
            <!--  <v-list-item-title>Statistiche aziendali</v-list-item-title>-->
            <!--</v-list-item>-->
          </v-list>
        </v-menu>

        <!-- GAMING -->
        <v-btn v-if="gamingAbilitato && bandoConSimulazioni" color="white" :to="{ name: 'gaming-dashboard-route' }" text>Gaming</v-btn>

        <!-- <v-btn v-if="computedDatiCliccatoreEnabled" color="white" @click="popUpDatiCliccatore()" text>Dati Cliccatore</v-btn> -->

        <v-btn @click="toggleSidebarNotifiche(), azzeraContatoreNotificheDaVisualizzare()" depressed text tile small class="white--text">
          <v-badge
            :content="numeroNotificheDaVisualizzare"
            :value="numeroNotificheDaVisualizzare"
            :color="scdOrange"
            overlap
          >
            <v-icon>
              mdi-bell
            </v-icon>
          </v-badge>
        </v-btn>

        <v-menu transition="slide-y-transition" bottom left nudge-bottom="50">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" depressed text tile small class="white--text">
              <v-icon data-tour-step="guida">help_outline</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="openGuide()">
              <v-list-item-title>Mostra guida</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openFAQ()">
              <v-list-item-title>Vai alle F.A.Q.</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn v-if="backofficeIsVisible" to="/backoffice" depressed text tile small class="white--text">
          <v-icon>
              mdi-view-dashboard
            </v-icon>
        </v-btn>

        <v-menu transition="slide-y-transition" bottom left nudge-bottom="50">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" depressed text tile small class="white--text">
              <v-icon data-tour-step="profilo">mdi-account-circle-outline</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="apriProfiloDialog()">
              <v-list-item-title>Il mio profilo</v-list-item-title>
            </v-list-item>
            <v-list-item @click="doLogout()">
              <v-list-item-title>Esci</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>

    <!-- <v-navigation-drawer app permanent :color="scdColor" dark clipped>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6">
            Back Office
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item link to="notifiche_route">
          <v-list-item-icon>
            <v-icon>mdi-bell</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Notifiche</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer> -->

    <v-main class="pt-0" style="height:100%">
      <router-view></router-view>
    </v-main>

    <!-- Notifiche -->
    <v-navigation-drawer width="500" right temporary absolute v-model="sidebarNotificheVisibile">
      <div style="text-align:center; color:#b1b1b1; margin:20px 0; font-size:16px; font-weight:700;">Le tue Notifiche</div>
      <div style="background-color:#dde6f3; padding:20px; margin:0 10px; min-height:calc(100% - 88px);">
        <div v-for="(notifica, index) in notifiche" :key="index"
          :style="`background-color:#fff; margin-bottom:20px; padding:20px; border:2px solid ${notifica.pivot.is_letta ? '#b1b1b1' : notifica.colore}`"
        >
          <div :style="`font-size:17px; font-weight:700; color:${ notifica.pivot.is_letta ? '#b1b1b1' : 'black' };`">{{ notifica.titolo }}</div>
          <div :style="`font-size:10px; font-weight:600; color: ${ notifica.pivot.is_letta ? '#b1b1b1' : notifica.colore }; padding: 0 0 5px; border-bottom: 1px solid #d1d1d1`">{{ notifica.nomeFrontend }}</div>
          <div :style="`margin: 7px 0 0; font-size:13px; color:${ notifica.pivot.is_letta ? '#b1b1b1' : '#434343' };`" v-html="notifica.testo"></div>
          <div style="font-size:10px; font-weight:600; margin-top:10px;" class="d-flex justify-space-between">
            <div style="color:#b1b1b1;">{{ notifica.tempoTrascorsoDallaNotifica }}</div>
            <div v-if="!notifica.pivot.is_letta" :style="`color:${ scdColor }; cursor:pointer;`" @click="segnaComeLetta(notifica.id, index)">Segna come letta</div>
            <div v-else-if="notifica.pivot.is_letta" :style="`color:${ scdColor }; cursor:pointer;`" @click="segnaComeDaLeggere(notifica.id, index)">Segna come da leggere</div>
          </div>
        </div>
      </div>
    </v-navigation-drawer>

    <v-dialog v-model="isProfiloDialogOpen" max-width="700">
      <v-card>
        <v-card-title class="headline">
          <span class="mr-2">Il mio profilo</span>
          <v-progress-circular v-if="isLoadingDatiProfilo" size="18" width="2" indeterminate :color="scdColor"></v-progress-circular>
          <v-spacer></v-spacer>
          <v-btn color="black--text" icon @click="isProfiloDialogOpen = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="profiloForm">
            <v-col class="px-4">
              <v-row>
                <v-col>
                  <v-text-field
										v-model="profilo.username" :disabled="!amIAdminOrTeamleader"
										autocomplete="new-username"
										label="Username *"
										:rules="[vincoli.required, vincoli.username]"
										outlined
										dense
									/>
                </v-col>
                <v-col>
                  <v-text-field
										v-model="profilo.password" autocomplete="new-password"
										:type="showPasswordInput ? 'text' : 'password'"
										:append-icon="showPasswordInput ? 'visibility_off' : 'visibility'"
										label="Cambia Password"
										:rules="[vincoli.password]"
										@click:append="showPasswordInput = !showPasswordInput"
										outlined
										dense
									/>
                </v-col>
              </v-row>
	            <v-row>
		            <v-col cols="6" class="py-0">
			            <v-text-field
				            v-model="profilo.nome"
				            autocomplete="none"
				            label="Nome (opzionale)"
				            outlined
				            dense
			            ></v-text-field>
		            </v-col>
		            <v-col cols="6" class="py-0">
			            <v-text-field
				            v-model="profilo.cognome"
				            autocomplete="none"
				            label="Cognome (opzionale)"
				            outlined
				            dense
			            ></v-text-field>
		            </v-col>
	            </v-row>
              <v-row class="mt-3">
                <v-col>
                  <v-text-field
										v-if="computedAmIAdmin"
										v-model="profilo.email"
										:disabled="amIProvaGratuita"
										autocomplete="new-email"
										label="Email di contatto"
										:rules="[vincoli.email, vincoli.required]"
										outlined
										dense
									/>
                  <v-text-field
										v-else-if="!computedAmIAdmin"
										v-model="profilo.email"
										:disabled="amIProvaGratuita"
										autocomplete="new-email"
										label="Email di contatto (opzionale)"
										:rules="[vincoli.email]"
										outlined
										dense
									/>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <v-text-field
										v-model="profilo.cellulare"
										:disabled="amIProvaGratuita"
										autocomplete="new-cellulare"
										label="Cellulare (opzionale)"
										:rules="[vincoli.numero_cellulare_cl]"
										outlined
										dense
									/>
                </v-col>
              </v-row>
            </v-col>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
						:color="scdColor"
						@click="isProfiloDialogOpen = false"
						:disabled="isSavingDatiProfilo"
						style="color: white"
						rounded
						depressed
					>
						Chiudi
					</v-btn>
          <v-btn
						:color="scdOrange"
						class="white--text"
						@click="setDatiProfilo()"
						:loading="isSavingDatiProfilo"
						rounded
						depressed
					>
						Salva
					</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-tour name="tour" :steps="tourSteps" :options="tourOptions"></v-tour>

    <v-snackbar v-model="showSnackbar" bottom :timeout="4000" v-if="alertType != null && message != null" :color="(alertType != 'error' ? scdColor : 'error')">
      {{ message }}
      <v-btn
				color="white"
				text
				@click="alertType = null"
				rounded
				depressed
			>
        Chiudi
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import mixin from '../mixins';

export default {
  data() {
    return {
      showSnackbar: false,
      alertType: null,
      message: null,

			bandoConSimulazioni: false,

      ruolo: window.__RUOLO__,
      username: window.__USERNAME__,

      isProfiloDialogOpen: false,
      isLoadingDatiProfilo: false,
      isSavingDatiProfilo: false,
      profilo: {
        username: null,
        email: null,
        cellulare: null,
	      nome: null,
	      cognome: null,
        password: null,
      },
      showPasswordInput: false,

      tourOptions: {
        useKeyboardNavigation: true,
        labels: {
          buttonSkip: 'Salta guida',
          buttonPrevious: 'Precedente',
          buttonNext: 'Successivo',
          buttonStop: 'Fine'
        },
        highlight: true
      },
      tourSteps: [], // Inizializzato dinamicamente da un'apposita funzione    

      notifiche: [],
      numeroNotificheDaVisualizzare: 0,
      IDsNotificheVisualizzateNellaViewport: 0,
      sidebarNotificheVisibile: false,
      backofficeIsVisible: false
    };
  },
  watch: {
    alertType: function(newVal){
      if(newVal != null){
        this.showSnackbar = true; // Mostra la Snackbar quando c'è un messaggio di successo/errore
      }
    },
    '$route' (to, from) {
      this.checkAperturaGuida(); // <= Chiamata anche nel mounted perché non viene chiamata altrimenti senza cambiare rotta (es. primo accesso)
    }
  },
  mounted: function () {
    // Apri guida in automatico al primo accesso
    // Non funziona messa nel created()!
    this.checkAperturaGuida(); // => Replicata anche nel watcher, perché il mounted non viene ri-chiamato cambiato rotta
  },
  created() {
    this.getNumeroNotificheDaVisualizzare();
		this.getIfBandoConSimulazioni();
    // this.getNotifichePerUtente();
    this.getIfBackofficeIsVisible();
    // if (window.__ID_CLIENTE__ == 2) {
    //   this.datiCliccatoreEnabled = true;
      
    // }
  },
  methods: {
		getIfBandoConSimulazioni() {
			axios.get('/bando/is-con-simulazioni')
				.then(response => {
					this.bandoConSimulazioni = response.data;
				})
		},
    getIfBackofficeIsVisible() {
      axios.get('/backoffice/is_visible')
        .then(res => {
          this.backofficeIsVisible = !!res.data;
        })
    },
    getNotifichePerUtente() {
      return axios.get('/notifiche/utente/get')
        .then(response => {
          this.notifiche = response.data;
          // console.log(this.notifiche);
        })
    },
    getNumeroNotificheDaVisualizzare() {
      return axios.get('/notifiche/get/numero-notifiche-da-visualizzare')
        .then(response => {
          this.numeroNotificheDaVisualizzare =  response.data;
        })
    },
    azzeraContatoreNotificheDaVisualizzare() {
      let numeroNotificheDaSottrarre = this.numeroNotificheDaVisualizzare;

      this.numeroNotificheDaVisualizzare = 0;

      if (numeroNotificheDaSottrarre > 0) {
        axios.post('/notifiche/segna-come-visualizzate', {
          notifiche: this.notifiche.filter(notifica => Boolean(notifica.pivot.is_visualizzata) == false),
        })
      }
    },
    async toggleSidebarNotifiche() {
      this.sidebarNotificheVisibile = !this.sidebarNotificheVisibile;

      if (this.sidebarNotificheVisibile) {
        await this.getNotifichePerUtente();
        await this.getNumeroNotificheDaVisualizzare();
        this.azzeraContatoreNotificheDaVisualizzare();
      }
      
    },
    // getColoreNotifica(tipo, is_letta) {
    //   if (is_letta) {
    //     return '#b1b1b1';

    //   } else {
    //     if (tipo == 'info_bando') {
    //       return '#1875ff';

    //     } else if (tipo == 'pagamento') {
    //       return '#6eb824';

    //     } else if (tipo == 'simulazioni_in_scadenza') {
    //       return '#ff5618';

    //     } else if (tipo == 'aggiornamento_simulatore') {
    //       return '#8f00ff';

    //     } 
    //   }
      
    // },
    // traduciTipoNotifica(tipo) {
    //   if (tipo == 'info_bando') {
    //     return 'Info Bando';

    //   } else if (tipo == 'pagamento') {
    //     return 'Pagamento';

    //   } else if (tipo == 'simulazioni_in_scadenza') {
    //     return 'Simulazioni in scadenza';

    //   } else if (tipo == 'aggiornamento_simulatore') {
    //     return 'Aggiornamento simulatore';
    //   }
    // },
    segnaComeLetta(id, index) {
      axios
      .post('/notifiche/segna-come-letta', {
        id: id
      })
      .then(response => {
        if (response.data.hasError) {
          
        } else {
          this.notifiche[index].pivot.is_letta = true;
        }
      })

    },
    segnaComeDaLeggere(id, index) {
      axios
      .post('/notifiche/segna-come-da-leggere', {
        id: id
      })
      .then(response => {
        if (response.data.hasError) {
          
        } else {
          this.notifiche[index].pivot.is_letta = false;
        }
      })

    },
    doLogout: function() {
      axios.get("/logout").then(response => {
        window.location.href = "/";
      });
    },
    goToDashboard: function(){
      this.$router.push('/');
    },
    apriProfiloDialog: function(){
      this.isProfiloDialogOpen = true;

      // Carico username ed email dell'utente
      this.getDatiProfilo();
    },
    getDatiProfilo: function(){
      this.isLoadingDatiProfilo = true;

      axios.get("/profilo")
        .then(response => {
          this.profilo = {
            username: response.data.username,
            email: response.data.email,
            cellulare: response.data.cellulare,
            nome: response.data.nome,
            cognome: response.data.cognome,
            password: null, // Mai inviata indietro dal server
          }
        })
        .catch(error => {
          console.log(error);
          this.alertType = "error";
          this.message = "Si è verificato un errore. Riprova"
        })
        .finally(() => {
          this.isLoadingDatiProfilo = false;
        });
    },
    setDatiProfilo: function(){
      this.alertType = null;
      this.message = null;
      
      if(!this.$refs.profiloForm.validate() || this.isSavingDatiProfilo) return;

      this.isSavingDatiProfilo = true;

      axios.patch("/profilo", this.profilo)
        .then(response => {
          if(response.data.hasError){
            this.alertType = "error";
            this.message = response.data.messages[0];
          } else {
            this.alertType = "success";
            this.message = "Dati profilo aggiornati";
            this.isProfiloDialogOpen = false;
          }
        })
        .catch(error => {
          console.log(error);
          this.alertType = "error";
          this.message = "Si è verificato un errore. Riprova"
        })
        .finally(() => {
          this.isSavingDatiProfilo = false;
        });
    },
    openGuide: function(){
      this.resetTourSteps();

      this.setTourSteps();
      setTimeout(() => {
        this.$tours['tour'].start(); // Avvio la guida
      }, 10);
      // this.$tours['tour'].start();
    },
    setTourSteps: function(){
      let currentUrl = window.location.href;

      let data = [];

      if(currentUrl.includes('account')){
        // TODO: mostrare questo step nella pagina SIMULAZIONI solo se è il primo accesso nel simulatore.
        // TODO: mostrare questo step in ogni pagina solo se l'utente ha cliccato MostraGuida
        // Step: Benvenuto nella guida interattiva del Simulatore Click Day!
        // ...
        // Clicca su “Successivo” per proseguire!
        data = [
          {
            target: '[data-tour-step-account="1"]',
            content: `Benvenuto nella tua sezione ACCOUNT! Questa sezione la puoi vedere soltanto tu in quanto sei l’amministratore dell’account.<br>`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-account="2"]',
            content: `Cliccando qui puoi scegliere con quale Bando svolgere le simulazioni di allenamento.<br>
                      Ogni Bando ha il proprio modello di allenamento e si basa sull’esperienza dei Click Day dei diversi Bandi degli anni passati.<br>
                      Solo l’amministratore dell’account può modificare il Bando.`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-account="3"]',
            content: `Da questa sezione puoi decidere a chi dare il permesso di modificare gli elementi contenuti nella Finestra Dati Personali di ogni account.<br>
                      Ricorda: alcuni Dati Personali verranno chiesti durante la simulazione.<br>
                      Solo l’amministratore dell’account può modificare questi permessi.`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-account="4"]',
            content: `In questa tabella puoi vedere, per ogni regione, i tempi più alti che sono risultati vincenti nell’ultima edizione del Bando selezionato.<br>
                      Utilizza questi tempi come riferimento per decidere quale deve essere il tempo da battere durante le simulazioni del cliccatore.`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-account="5"]',
            content: `Scrivi qui i secondi che il cliccatore deve battere per vincere la simulazione.<br>
            Questo significa che la simulazione risulterà vinta se il cliccatore riuscirà ad inviare il Click in un tempo INFERIORE a quello che inserisci.<br>
            Utilizza la tabella a fianco come riferimento.<br>
            Solo l’amministratore dell’account può modificare questo tempo.`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-account="6"]',
            content: `Qui invece puoi vedere il dettaglio del tuo piano di abbonamento.`,
            params: {
              enableScrolling: false,
              placement: 'top'
            }
          },
          {
            target: '[data-tour-step-account="7"]',
            content: `Se stai per finire le simulazioni, puoi cliccare su questo bottone per acquistarne delle altre.`,
            params: {
              enableScrolling: false,
              placement: 'top'
            }
          },
        ]
      } else if (currentUrl.includes('cliccatori')) {
        if(window.__RUOLO__ == 'Teamleader'){
          data = [
            {
              target: '[data-tour-step-cliccatori="0"]',
              content: `Benvenuto nella tua sezione CLICCATORI!<br><br>
              In questa sezione puoi gestire la tua Squadra, in quanto Coordinatore puoi creare nuovi cliccatori e gestirli.`,
              params: {
                enableScrolling: false,
                placement: 'bottom'
              }
            }
          ];
        }
        if(window.__RUOLO__ == 'Admin'){
          data = [
            {
              target: '[data-tour-step-cliccatori="0"]',
              content: `Benvenuto nella tua sezione CLICCATORI!<br><br>
              In questa sezione potrai gestire le tue squadre ed i tuoi cliccatori.<br>`,
              params: {
                enableScrolling: false,
                placement: 'bottom'
              }
            },
            {
              target: '[data-tour-step-cliccatori="1"]',
              content: `Inizia dando un'occhiata al nome della squadra ed all'username del coordinatore (se assegnato).`,
              params: {
                enableScrolling: false,
                placement: 'bottom'
              }
            },
            {
              target: '[data-tour-step-cliccatori="1a"]',
              content: `Questo pannello ti permette di selezionare la squadra che vuoi gestire.`,
              params: {
                enableScrolling: false,
                placement: 'right-start'
              }
            },
          ];

          if (window.__NOME_PACCHETTO__ == 'CONSULENTE' || window.__NOME_PACCHETTO__ == 'DEVELOPER') {
            data.push(
              {
                target: '[data-tour-step-cliccatori="1b"]',
                content: `Per aggiungere una squadra clicca qui.<br>
                A fianco ad ogni squadra che crei trovi un interruttore per attivarla o disattivarla.<br>
                Quando metti l'interruttore della squadra sul verde vuol dire che la squadra è attiva e i cliccatori al suo interno possono allenarsi.<br>
                Quando metti l'interruttore sul bianco vuol dire che la squadra è spenta e i suoi cliccatori non possono fare simulazioni.`,
                params: {
                  enableScrolling: false,
                  placement: 'right-start'
                }
              },
            )
          }
        }

        data.push(
          {
            target: '[data-tour-step-cliccatori="2"]',
            content: `Usando questo bottone puoi creare nuovi cliccatori.`,
            params: {
              enableScrolling: false,
              placement: 'right-start'
            }
          },
          {
            target: '.data-tour-step-cliccatori-3',
            content: `Questa tabella mostra tutti i cliccatori della squadra.`,
            params: {
              enableScrolling: false,
              placement: 'top'
            }
          },
          {
            target: '.data-tour-step-cliccatori-4',
            content: `1. Puoi monitorare le Simulazioni eseguite ed il Tempo medio di ogni cliccatore (non sono considerate le simulazioni abbandonate).`,
            params: {
              enableScrolling: false,
              placement: 'top'
            }
          },
          {
            target: '.data-tour-step-cliccatori-5',
            content: `2. Puoi attivare o disattivare il cliccatore attraverso l'interruttore che si trova nella colonna "Stato". Se l'interrutorre è verde il Cliccatore potrà svolgere simulazioni, se è bianco no.`,
            params: {
              enableScrolling: false,
              placement: 'top'
            }
          },
          {
            target: '.data-tour-step-cliccatori-6',
            content: `3. Puoi modificare il loro profilo (Tasto "Modifica"), guardare le loro Statistiche e gestire i Dati Personali del Cliccatore, cioè le informazioni relative all'azienda ed alla persona che esegue l’invio della domanda.<br><br>
            Se hai dubbi sul funzionamento o vorresti delle modifiche, non esitare a contattarci! :)`,
            params: {
              enableScrolling: false,
              placement: 'top'
            }
          },
        );
      } else if (currentUrl.includes('statistiche_cliccatore')) {
      //   // Guida"Statistiche Personali"
        data = [
          {
            target: '[data-tour-step-statistiche="1"]',
            content: `<b>Benvenuto nella sezione Statistiche Personali!</b></br><br>In questa pagina puoi vedere come stai andando, rispetto al tempo da battere impostato dall'amministratore e rispetto alla tua Squadra!`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-statistiche="2"]',
            content: `Scegli il periodo del quale vuoi avere informazioni!<br/>Ogni volta che entri in questa pagina saranno selezionati in automatico gli ultimi sette giorni.`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-statistiche="3"]',
            content: `Questa sezione mostra i risultati dei tuoi allenamenti nel periodo temporale scelto. Guarda il Tempo medio che hai realizzato e il numero di Simulazioni eseguite. Se passi con il mouse sul grafico a torta puoi vedere anche quante ne hai vinte, perse e abbandonate :)`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-statistiche="4"]',
            content: `Il grafico mostra come migliorano i tuoi tempi all’aumentare delle simulazioni svolte. Puoi nascondere dei valori dal grafico cliccando sui rettangoli colorati di ogni statistica e concentrarti solo su ciò che ti interessa di più. Sfrutta questo grafico per osservare i tuoi progressi grazie all’allenamento!`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-statistiche="5"]',
            content: `Questa tabella riporta le informazioni dettagliate di ogni Simulazione svolta! Puoi cercare velocemente una specifica simulazione inserendo la data in cui l’hai svolta nel campo “Cerca data simulazione” a sinistra. Clicca sul pulsante "Dettagli Simulazione" per vedere nuovamente tutta la Simulazione svolta.<br><br>
                      Molto semplice, non trovi? Se sei un Coordinatore o un Amministratore, dai un'occhiata anche alla sezione Statistiche Squadra e Statistiche Azienda :)
`,
            params: {
              enableScrolling: false,
              placement: 'top'
            }
          }
        ];
      } else if (currentUrl.includes('statistiche_squadre')) {
        data = [
          {
            target: '[data-tour-step-statistiche="1"]',
            content: `<b>Benvenuto nella sezione Statistiche Squadre!</b></br><br>In questa pagina puoi vedere come stanno andando le tue squadre, rispetto al tempo da battere impostato dall'amministratore e rispetto alla tua Azienda!`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-statistiche="2"]',
            content: `Seleziona di quale squadra vuoi vedere le statistiche. Ogni volta che entri in questa pagina sarà selezionata in automatico la voce Senza Squadra.`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-statistiche="3"]',
            content: `Scegli il periodo del quale vuoi avere informazioni!<br/>Ogni volta che entri in questa pagina saranno selezionati in automatico gli ultimi sette giorni.`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-statistiche="4"]',
            content: `Questa sezione mostra i risultati degli allenamenti della squadra selezionata nel periodo temporale scelto. Guarda il Tempo medio e il numero di Simulazioni eseguite. Se passi con il mouse sul grafico a torta puoi vedere anche quante sono state quelle vinte, perse e abbandonate :)`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-statistiche="5"]',
            content: `Il grafico mostra come migliorano i tempi della squadra all’aumentare delle simulazioni svolte. Puoi nascondere dei valori dal grafico cliccando sui rettangoli colorati di ogni statistica e concentrarti solo su ciò che ti interessa di più. Sfrutta questo grafico per osservare i progressi delle squadre grazie all’allenamento!
`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-statistiche="6"]',
            content: `Questa tabella riporta le statistiche di ogni Cliccatore appartenente alla squadra scelta! Puoi cercare velocemente un cliccatore per username usando il campo “Cerca cliccatore” a sinistra. Se vuoi mostrare nel grafico anche i tempi medi di un cliccatore, attiva l'interruttore che si trova nella colonna "Mostra nel grafico". Cliccando sul pulsante “Statistiche” di ogni cliccatore vedrai nel dettaglio le sue statistiche personali.`,
            params: {
              enableScrolling: false,
              placement: 'top'
            }
          }
        ];
      } else if (currentUrl.includes('statistiche_azienda')) {
        data = [
          {
            target: '[data-tour-step-statistiche="1"]',
            content: `<b>Benvenuto nella sezione Statistiche Aziendali!</b></br><br>In questa pagina puoi vedere come sta andando la tua Azienda!`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-statistiche="2"]',
            content: `Scegli il periodo del quale vuoi avere informazioni!<br/>Ogni volta che entri in questa pagina saranno selezionati in automatico gli ultimi sette giorni.`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-statistiche="3"]',
            content: `Questa sezione mostra i risultati degli allenamenti dell’azienda nel periodo temporale scelto. Guarda il Tempo medio e il numero di Simulazioni eseguite. Se passi con il mouse sul grafico a torta puoi vedere anche quante ne sono state vinte, perse e abbandonate :)`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-statistiche="4"]',
            content: `Il grafico mostra come migliorano i tempi dell’azienda all’aumentare delle simulazioni svolte. Puoi nascondere dei valori dal grafico cliccando sui rettangoli colorati di ogni statistica e concentrarti solo su ciò che ti interessa di più. Sfrutta questo grafico per osservare i progressi dell’azienda grazie all’allenamento!`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-statistiche="5"]',
            content: `Questa tabella riporta le statistiche dettagliate di ogni Squadra appartenente all’Azienda! Puoi cercare velocemente una squadra scrivendone il nome nel campo “Cerca squadra” a sinistra. Se vuoi mostrare nel grafico anche i tempi medi di una squadra, attiva l'interruttore che si trova nella colonna "Mostra nel grafico".`,
            params: {
              enableScrolling: false,
              placement: 'top'
            }
          }
        ];

      } else { // Root => Pagina Simulazioni
        // TODO:: 
        window.__IS_FIRST_ACCESS_SIMULAZIONE__ = '1'
        axios.get('/cliccatore/setFirstAccesSimulazioneOnTrue')
        // fare una chiamata Axios per settare  
        // is_first_access_simulazione = 1 (valore DB)

        let numeroMinimoSimulazioniSelezione = this.minimoSimulazioniSelezioneComputed;
        if(!numeroMinimoSimulazioniSelezione) numeroMinimoSimulazioniSelezione = 100;

        if (window.__IS_FIRST_ACCESS_SIMULAZIONI__ == '1') {
          data.push(
            {
              target: '[data-tour-step-simulazioni="0"]',
              content: `<b>Benvenuto nella guida interattiva del Simulatore Click Day!</b>`,
              params: {
                enableScrolling: false,
                placement: 'right-start'
              }
            }
          );
        }

        if(window.__RUOLO__ == 'Admin'){
          data.push(
            {
              target: '[data-tour-step-simulazioni="1"]',
              content: `Segui questa breve guida per scoprire quanto è semplice usare il Simulatore Click Day!<br><br>Questa qui è la tua Squadra di appartenenza: se il tuo pacchetto lo prevede, puoi creare nuove squadre e assegnare ad ognuna di loro un Coordinatore.`,
              params: {
                enableScrolling: false,
                placement: 'right-start'
              }
            }
          );

        } else if(window.__RUOLO__ == 'Teamleader') {
          data.push(
            {
              target: '[data-tour-step-simulazioni="1"]',
              content: `Segui questa breve guida per scoprire quanto è semplice usare il Simulatore Click Day!<br><br>Questa qui è la tua Squadra di appartenenza: essendo tu il Coordinatore è la Squadra che dovrai gestire!`,
              params: {
                enableScrolling: false,
                placement: 'right-start'
              }
            }
          );

        } else {
          data.push(
            {
              target: '[data-tour-step-simulazioni="1"]',
              content: `Segui questa breve guida per scoprire quanto è semplice usare il Simulatore Click Day!<br><br>Questa qui è la tua Squadra di appartenenza.`,
              params: {
                enableScrolling: false,
                placement: 'right-start'
              }
            }
          );
        }

        data.push(
          {
            target: '[data-tour-step-simulazioni="2"]',
            content: `Questo è lo username del tuo Coordinatore.`,
            params: {
              enableScrolling: false,
              placement: 'right-start'
            }
          },
          {
            target: '[data-tour-step-simulazioni="3"]',
            content: `Queste sono le simulazioni totali che hai eseguito`,
            params: {
              enableScrolling: false,
              placement: 'right-start'
            }
          },
          {
            target: '[data-tour-step-simulazioni="4"]',
            content: `Questo è il tempo da battere. Devi riuscire ad eseguire simulazioni rimanendo sotto questo tempo! ${window.__RUOLO__ == 'Admin' ? 'Puoi modificarlo dalla pagina ACCOUNT.' : `Solo l’amministratore dell’account può modificare questo tempo.`}`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-simulazioni="5"]',
            content: `Qui trovi le statistiche delle ultime ${numeroMinimoSimulazioniSelezione} simulazioni che hai fatto. Per vedere le statistiche complete vai nella sezione “STATISTICHE” dal menù in alto a destra.`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-simulazioni="6"]',
            content: `Queste sono le tue simulazioni vincenti, ovvero quelle in cui hai raggiunto un tempo inferiore al tempo da battere. Devi ottenerne il più possibile!`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-simulazioni="7"]',
            content: `Queste sono invece le simulazioni in cui hai fatto un tempo superiore al tempo da battere.`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-simulazioni="8"]',
            content: `Qui trovi le simulazioni che abbandoni. Se entri in una simulazione ma non la esegui, allora verrà considerata come abbandonata. Ti sconsigliamo di abbandonare simulazioni se le trovi difficili, il Click Day non puoi saltarlo!`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-simulazioni="9"]',
            content: `Questo invece è il tuo tempo medio. E' il dato più importante! Lo scopo è cercare di mantenerlo sempre al di sotto del Tempo da Battere!`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-simulazioni="10"]',
            content: `Concludendo con la parte di statistiche, qui trovi informazioni dettagliate delle tue ultime 5 simulazioni (sbircia anche come sono andati gli altri cliccatori).`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-simulazioni="11"]',
            content: `Cliccando su questo bottone si aprirà una lista di informazioni finte relative all'azienda e alla persona che esegue l’invio della domanda. Avrai la possibilità di personalizzarle cliccando su ognuna di esse.<br>
            Ogni volta che avvierai una nuova simulazione dovrai inserire <b>alcuni</b> di questi dati in base al tipo di bando ${window.__RUOLO__ == 'Admin' ? 'che hai scelto nella pagina ACCOUNT.' : `scelto dall’Amministratore dell’account.`}`,
            params: {
              enableScrolling: false,
              placement: 'bottom'
            }
          },
          {
            target: '[data-tour-step-simulazioni="12"]',
            content: `In questa zona trovi l'elenco delle simulazioni disponibili a intervalli di 10 secondi.`,
            params: {
              enableScrolling: false,
              placement: 'left'
            }
          },
        );

        // NOTA: se sono in modalità Mobile, non mostro la guida sulle voci di menù!
        if(!this.$vuetify.breakpoint.smAndDown){
          // Inserisco uno step opzionale
          if(window.__RUOLO__ == 'Admin' || this.amIProvaGratuita){
            data.push({
              target: '[data-tour-step="account"]',
              content: `Qui puoi gestire le informazioni relative al tuo account!`,
              params: {
                enableScrolling: false,
                placement: 'bottom'
              }
            });
          }
          if(window.__RUOLO__ != 'Cliccatore' || this.amIProvaGratuita){
            data.push({
              target: '[data-tour-step="cliccatori"]',
              content: `Qui puoi amministrare la tua squadra!`,
              params: {
                enableScrolling: false,
                placement: 'bottom'
              }
            });
          }
        
          data.push(
            {
              target: '[data-tour-step="statistiche"]',
              content: `Qui vedi le statistiche dettagliate`,
              params: {
                enableScrolling: false,
                placement: 'bottom'
              }
            },
            {
              target: '[data-tour-step="guida"]',
              content: `Se desideri rivedere la guida della pagina in cui ti trovi, clicca qui`,
              params: {
                enableScrolling: false,
                placement: 'left-start'
              }
            },
            {
              target: '[data-tour-step="profilo"]',
              content: `Qui puoi modificare il tuo profilo o uscire dal Simulatore quando hai finito di utilizzarlo!`,
              params: {
                enableScrolling: false,
                placement: 'left-start'
              }
            },
          )
        }

        let contenutoDinamico = '';
        if (window.__ID_CLIENTE__ == 1 || window.__ID_CLIENTE__ == 2) {
          contenutoDinamico = `Se hai simulazioni disponibili, clicca su una di queste per effettuare la tua prima Simulazione!<br><br>
            Ricorda di aprire la Finestra Dati Personali e di tenerla al lato dello schermo a portata di mano mentre esegui la simulazione.<br><br>
            <b>La guida continuerà alla prima Simulazione di prova.</b><br><b>Buon Allenamento :)</b>`

        } else {
          contenutoDinamico = `Se hai simulazioni disponibili, clicca su una di queste per effettuare la tua prima Simulazione!<br><br>
            Ricorda di copiare su un blocco note i dati presenti nella Finestra Dati Personali in modo da averli sempre a portata di mano mentre esegui la simulazione.<br><br>
            <b>La guida continuerà alla prima Simulazione di prova.</b><br><b>Buon Allenamento :)</b>`
        }

        // se il cliente è clickday inserire questa frase:
        // Ricorda di aprire la Finestra Dati Personali e di tenerla al lato dello schermo a portata di mano mentre esegui la simulazione<br><br>
        // altrimenti quest'altra
        // (i clienti hanno la modale non il popup)

        data.push(
          {
            target: '[data-tour-step-simulazioni="13"]',
            content: contenutoDinamico,
            params: {
              enableScrolling: false,
              placement: 'left'
            }
          }
        )

      }

      this.tourSteps = data;
    },
    openFAQ: function(){
      window.open("https://simulatoreclickday.it/#faq", "_blank");
    },
    resetTourSteps: function(){
      this.tourSteps = [];
    },
    checkAperturaGuida: function(){
      let currentUrl = window.location.href;

      if(currentUrl.includes('account')){
        if(window.__IS_FIRST_ACCESS_ACCOUNT__ == '1'){
          this.setTourSteps();
          setTimeout(() => {
            this.$tours['tour'].start(); // Avvio la guida
          }, 10);
          window.__IS_FIRST_ACCESS_ACCOUNT__ = '0'; // Pongo a 0 il valore attuale del Front End
          axios.get("/cliccatore/accessedAccount"); // Aggiorno valore nel DB:
        }
      } else if (currentUrl.includes('cliccatori')) {
        if(window.__IS_FIRST_ACCESS_CLICCATORI__ == '1'){
          this.setTourSteps();
          setTimeout(() => {
            this.$tours['tour'].start(); // Avvio la guida
          }, 10);
          window.__IS_FIRST_ACCESS_CLICCATORI__ = '0'; // Pongo a 0 il valore attuale del Front End
          axios.get("/cliccatore/accessedCliccatori"); // Aggiorno valore nel DB:
        }
      } else if (currentUrl.includes('statistiche_cliccatore')) {
        if(window.__IS_FIRST_ACCESS_STATISTICHE_CLICCATORE__ == '1'){
          this.setTourSteps();
          setTimeout(() => {
            this.$tours['tour'].start(); // Avvio la guida
          }, 10);
          window.__IS_FIRST_ACCESS_STATISTICHE_CLICCATORE__ = '0'; // Pongo a 0 il valore attuale del Front End
          axios.get("/cliccatore/accessedStatisticheCliccatore"); // Aggiorno valore nel DB:
        }
      } else if (currentUrl.includes('statistiche_squadre')) {
        if(window.__IS_FIRST_ACCESS_STATISTICHE_SQUADRE__ == '1'){
          this.setTourSteps();
          setTimeout(() => {
            this.$tours['tour'].start(); // Avvio la guida
          }, 10);
          window.__IS_FIRST_ACCESS_STATISTICHE_SQUADRE__ = '0'; // Pongo a 0 il valore attuale del Front End
          axios.get("/cliccatore/accessedStatisticheSquadre"); // Aggiorno valore nel DB:
        }
      } else if (currentUrl.includes('statistiche_azienda')) {
        if(window.__IS_FIRST_ACCESS_STATISTICHE_AZIENDA__ == '1'){
          this.setTourSteps();
          setTimeout(() => {
            this.$tours['tour'].start(); // Avvio la guida
          }, 10);
          window.__IS_FIRST_ACCESS_STATISTICHE_AZIENDA__ = '0'; // Pongo a 0 il valore attuale del Front End
          axios.get("/cliccatore/accessedStatisticheAzienda"); // Aggiorno valore nel DB:
        }
      } else { // Root => Pagina Simulazioni
        if(window.__IS_FIRST_ACCESS_SIMULAZIONI__ == '1'){
          this.setTourSteps();
          setTimeout(() => {
            this.$tours['tour'].start(); // Avvio la guida
          }, 10);
          
          window.__IS_FIRST_ACCESS_SIMULAZIONI__ = '0'; // Pongo a 0 il valore attuale del Front End
          axios.get("/cliccatore/accessedSimulazioni"); // Aggiorno valore nel DB:
        }
      }
    
    },
    popUpDatiCliccatore() {
      // == Tab ==
      // let a = document.createElement('a');
      // a.target='_blank';
      // a.href='datiCliccatore/';
      // a.click();

      // == Popup ==
      var w = 350;
      var h = 700;
      // var l = Math.floor((screen.width-w)/2); // distanza dal bordo sinistro dello schermo
      var l = 0;
      var t = Math.floor((screen.height-h)/2);
      window.open("datiCliccatore/","","width=" + w + ",height=" + h + ",top=" + t + ",left=" + l);

    }
  }
};
</script>

<style lang="scss" scoped>
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600&display=swap');

  ._home {
    font-family: 'Montserrat', sans-serif !important;
    // font-size: 14px;
    // color: #6D94CD;
    // font-weight: 400;
    // line-height:1.5;
    // padding-top: 20px;
  }

	.menu_buttons_uppercase .v-btn {
		text-transform: uppercase !important;
	}
</style>